<template class="hide-overflow">
  <div class="hide-overflow">
    <v-row>

      <v-col cols="8">
        <div style="margin-top: auto !important; margin-bottom: auto !important" class="grad">
          <v-col align="center" justify="center">
            <img src="@/assets/login-screen.png" class="img" />
          </v-col>
          <v-row class="mt-*">
            <v-col cols="4" align="center" justify="center">
              <img src="@/assets/logo-paoli.png" :height="60" />
            </v-col>
            <v-col cols="4" align="center" justify="center">
              <img src="@/assets/logo-bej.png" :height="60" />
            </v-col>
            <v-col cols="4" align="center" justify="center">
              <img src="@/assets/logo-inocencio-paula.png" :height="60" />
            </v-col>
          </v-row>
         
          <v-row justify="center" class="mt-10 mb-2">
            <v-col cols="auto" class="text-right">
              <a
                href="https://mazzitech.com.br"
                target="_blank"
                rel="noopener noreferrer"
                class="text-decoration-none d-inline-flex flex-column align-end mr-5"
                title="Desenvolvido por Mazzitech"
              >
                <span class="grey--text text--darken-2 mr-2 mb-n2" style="font-size: 0.75rem;">Powered by</span>
                <v-img
                  src="@/assets/logo-mazzitech.svg"
                  alt="Logo da Mazzitech"
                  contain
                  max-width="130"
                  class="mt-1 image-footer"
                ></v-img>
              </a>
            </v-col>
          </v-row>
     
        </div>
      </v-col>

      <v-col cols="4" style="overflow-y: hidden !important">
        <v-container :class="$platform.isMobile() ? 'px-10' : ''" fill-height grid-list-md text-xs-center>
          <v-row justify="center" style="margin: 0px">
            <v-col cols="12" class="mr-5" justify="space-between">
              <v-img
                src="@/assets/logo-123milhas.png"
                contain
                max-width="300"
                class="mx-auto mt-n10"
              ></v-img>
              <v-row style="padding: 60px 0px 0px 0px; overflow-y: hidden !important">
                <div class="mb-10">
                  <span class="title-login">Acesso Administrativo</span>
                  <br>
                  <span class="darkGray--text">Informe seu e-mail e senha para acessar</span>
                </div>
              </v-row>
              <v-row justify="center" style="height: 300px">
                <v-form ref="form" v-model="loginForm.validForm" lazy-validation style="width: 100%"
                  @submit.prevent="login">
                  <v-text-field placeholder="Digite seu e-mail" label="E-mail" ref="username" outlined
                    :rules="[$rules.required, $rules.email]" v-model="loginForm.user.username"></v-text-field>

                  <v-text-field outlined label="Senha" :append-icon="loginForm.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    required :rules="[$rules.required]" :type="loginForm.showPassword ? 'text' : 'password'"
                    v-model="loginForm.user.password" @click:append="loginForm.showPassword = !loginForm.showPassword"
                    hide-details="auto" class="mb-4" id="password"></v-text-field>

                  <v-row justify="center">
                    <v-col>
                      <v-btn v-if="$platform.isMobile()" width="100%" color="primary" elevation="2" x-large
                        style="height: 56px; margin-top: 10px" :loading="loginForm.loading"
                        type="submit">Acessar</v-btn>
                      <v-btn v-else large color="primary" elevation="2"
                        style="margin-top: 10px; width: 100%; height: 56px;" :loading="loginForm.loading"
                        type="submit">Entrar</v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col>
                      <v-btn text small color="primary" @click="dialogForgotPassword = true">
                        Esqueci minha senha
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>

      <v-dialog v-model="dialogForgotPassword" :width="700">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col>
                <div class="font-weight-bold mt-6 title-page" tabindex="0">Recuperação de Senha</div>
                <p class="mt-8 mb-n1" tabindex="0">
                  Informe o seu e-mail de acesso para iniciar a recuperação da sua senha.
                </p>
              </v-col>
            </v-row>
            <v-form ref="form" v-model="validForm">
              <v-row>
                <v-col>
                  <v-text-field dense id="username" label="E-mail" tabindex="0"
                    aria-label="Digite seu email para fazer a recuperação de sua senha" v-model="dataset.data.email"
                    required :rules="[$rules.required, $rules.email]" outlined hide-details="auto">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-text>
            <v-btn color="primary" @click.native="sendRecoverPassaword()" :loading="loading" tabindex="0"
              aria-label="Botão para enviar a solicitação de recuperação de senha">Finalizar</v-btn>
            <v-btn color="grey" text @click.native="dialogForgotPassword = false" tabindex="0"
              aria-label="Botão para cancelar e não solicitar nova senha de acesso">Cancelar</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-if="recoveryToken" persistent v-model="dialogRecoverPassword" :width="600" tabindex="0"
        aria-label="Recuperação de senha">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col>
                <div class="font-weight-bold mt-6 title-page">Recuperação de Senha</div>
                <p class="mt-8 mb-n1">
                  Insira a sua nova senha abaixo.
                </p>
              </v-col>
            </v-row>
            <v-form ref="form" v-model="validForm">
              <v-row>
                <v-col>
                  <v-text-field dense outlined label="Nova senha"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" required
                    :rules="[$rules.required, $rules.strongPassword]" :type="showPassword ? 'text' : 'password'"
                    v-model="dataset.data.password" @click:append="showPassword = !showPassword" hide-details="auto"
                    class="mb-4" id="password"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field dense outlined label="Confirmação da nova senha"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" required :rules="[
                      $rules.required,
                      dataset.data.password ===
                      dataset.data.passwordConfirmation ||
                      'As senhas não coincidem.',
                    ]" :type="showPassword ? 'text' : 'password'" v-model="dataset.data.passwordConfirmation"
                    @click:append="showPassword = !showPassword" hide-details="auto" class="mb-4"
                    id="password"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-text>
            <v-btn color="primary" @click.native="finish" :loading="loading">Concluir</v-btn>
            <v-btn color="grey" text @click.native="dialogRecoverPassword = false">Cancelar</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

    </v-row>
  </div>
</template>

<script>
import Vue from "vue";
import axios from 'axios';
import router from '../router';
import * as jwt from "jwt-decode";

export default {
  name: "Login",

  data: () => ({
    page: {
      slogan: null,
    },
    username: "",
    password: "",
    loading: false,
    dialogForgotPassword: false,
    validForm: false,
    recoveryToken: null,
    dialogRecoverPassword: false,
    dataset: {
      data: {}
    },
    valid: true,
    show: false,
    showPassword: false,
    rules: {
      email: [
        (v) => !!v || "O usuário é obrigatório",
        // (v) =>
        //   (v && v.length <= 25) ||
        //   "O usuário deve ter menos de 10 caracteres",
      ],
      password: [(v) => !!v || "A senha é obrigatória"],
    },
    loginForm: {
      validForm: true,
      showPassword: false,
      loading: false,
      user: {},
    },
  }),

  props: {
    token: null
  },

  mounted() {
    if (this.$route.query.username) {
      this.loginForm.user.username = this.$route.query.username;
    }

    if (this.$route.query.recoveryToken) {
      this.verifyRecoverPasswordToken(this.$route.query.recoveryToken)
    }
  },

  methods: {
    empty() {
      return (
        !this.$data.loginForm.user.username ||
        !this.$data.loginForm.user.password
      );
    },
    async login() {

      if (!this.$refs.form.validate()) return;

      let data = {
        email: this.loginForm.user.username,
        password: this.loginForm.user.password,
        type: 2,
      };

      this.$data.loginForm.loading = true;

      try {
        const result = await axios.post('/api/admin/login', data);

        if (!result.data.status) throw new Error();

        localStorage.setItem('token', JSON.stringify(result.data.content));

        var dataUser = jwt(result.data.content.token);

        console.log('dataUser', dataUser)

        this.$root.user = dataUser.data;
        localStorage.setItem('user', JSON.stringify(dataUser));

        router.push("/home");

      } catch (error) {
        console.log('error ', error)
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
        this.$data.loginForm.user.password = "";
      } finally {
        this.$data.loginForm.loading = false;
      }
    },

    async sendRecoverPassaword() {

      if (!this.$refs.form.validate()) return;

      let data = {
        email: this.dataset.data.email,
      };

      this.loading = true;

      try {
        const result = await axios.post('/api/admin/forgot-password', data);

        if (!result.data.status) throw new Error();

        await this.$dialog.confirm({
          text: 'E-mail enviado com sucesso! Siga as instruções enviadas para recuperar sua conta.',
          title: 'Sucesso',
          actions: {
            true: 'OK'
          }
        })

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
      } finally {
        this.dataset.data = {}
        this.loading = false;
        this.dialogForgotPassword = false;
      }
    },

    async verifyRecoverPasswordToken(token) {
      if (!token) return

      this.recoveryToken = decodeURIComponent(token.toString().replaceAll(' ', '+'))

      this.dialogRecoverPassword = true
    },

    async finish() {

      if (!this.$refs.form.validate()) return;

      let data = {
        password: this.dataset.data.password,
        token: this.$route.query.recoveryToken
      };

      this.loading = true;

      try {
        const result = await axios.post('/api/admin/change-password', data);

        if (!result.data.status) throw new Error();

        await this.$dialog.confirm({
          text: 'Senha alterada com sucesso!',
          title: 'Sucesso',
          actions: {
            true: 'OK'
          }
        })

       this.dialogRecoverPassword = false;

       this.$router.push("/login");

       setTimeout(() => {
          window.location.reload();
        }, 500);

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
      } finally {
        this.dataset.data = {}
        this.loading = false;
      }
    },

  },
};
</script>

<style scoped lang="scss">
.grad {
  //background-image: linear-gradient(to right, #014373, #80a1b9);
  background: #e6ecf1;
  height: 100vh;
  width: 100%;
  //border: 3px solid green;
}

.img {
  width: 70%;
  height: auto;
  margin: auto;
  opacity: 100% !important;
  padding: 10px 0px 0px 0px;
}

.hide-overflow {
  overflow: hidden;
}

.no-scroll,
#no-scroll {
  overflow: hidden;
}

.hide-overflow::-webkit-scrollbar {
  display: none;
  /* Chrome */
}

.bottom-text {
  position: relative !important;
  font-size: 10px;
  color: #595959;
  margin-bottom: 30px;
  padding-top: 0px;
}



.btn-forgot-password {
  font-size: 14px;
  color: #9fa1a4;
  font-weight: 400;
}

.title-login {
  color: var(--v-black-base);
  font-family: "Plus Jakarta Sans", "Roboto", sans-serif;
  // font-family: 'Avenir LT Std';
  font-size: 34px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px
}

.btn-login {
  text-transform: none !important;
  letter-spacing: 1px;
  font-weight: 400;
}
</style>
